import { Link } from "react-router-dom";
import { Package, ArrowRight } from "lucide-react";

const STEPS = ["Orçamento aprovado", "Em produção", "Controle de qualidade", "Pronto para entrega"];

export default function Pedidos() {
  return (
    <div data-testid="portal-orders-page">
      <h1 className="display text-3xl sm:text-4xl font-extrabold uppercase">Pedidos</h1>
      <p className="mt-1 text-sm text-zinc-500">
        Pedidos são gerados automaticamente quando um orçamento é aprovado.
      </p>

      <div className="mt-8 card-tactical rounded-md p-6" data-testid="portal-orders-steps">
        <h2 className="display text-xl font-bold uppercase tracking-wide">Como funciona</h2>
        <ol className="mt-5 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-start gap-3">
              <span className="mono shrink-0 w-8 h-8 grid place-content-center border border-orange-600 text-orange-500 rounded-sm text-sm font-semibold">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-sm text-zinc-400 leading-snug pt-1.5">{s}</span>
            </li>
          ))}
        </ol>
      </div>

      <div className="mt-6 card-tactical rounded-md py-16 text-center" data-testid="portal-orders-empty">
        <Package className="w-10 h-10 text-zinc-700 mx-auto" strokeWidth={1.25} />
        <p className="mt-4 text-sm text-zinc-500">Nenhum pedido em andamento no momento.</p>
        <Link
          to="/painel/orcamentos/novo"
          data-testid="portal-orders-new-quote-link"
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-orange-500 hover:text-orange-400"
        >
          Solicitar um orçamento <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
